<template>
  <div v-if="label !== null" class="promotion-timer" :class="label">
    <p class="promotion-timer__text">
      {{ _T(types[label].topText) }}
    </p>

    <p v-if="daysLeft > 0" class="promotion-timer__number">{{ daysLeft }}</p>

    <p class="promotion-timer__text">
      {{ _T(types[label].bottomText) }}
    </p>
  </div>
</template>

<script setup>
const props = defineProps({
  daysLeft: { required: true },
});

const label = ref(null);

const classType = {
  novelty: "novelty",
  runningOut: "runningOut",
  onlyToday: "onlyToday",
  finished: "finished",
};

const types = {
  [classType.novelty]: {
    topText: "@Promotion days left",
    bottomText: "@Days",
  },
  [classType.runningOut]: {
    topText: "@Promotion days left",
    bottomText: "@Days",
  },
  [classType.onlyToday]: {
    topText: "@Only",
    bottomText: "@Today",
  },
  [classType.finished]: {
    topText: "@Promotion",
    bottomText: "@finished",
  },
};

function initClass() {
  if (props.daysLeft > 0) {
    return props.daysLeft > 5 ? "novelty" : "runningOut";
  }

  if (props.daysLeft === 0) {
    return "onlyToday";
  }

  return "finished";
}

onMounted(() => {
  label.value = initClass();
});
</script>

<style lang="scss" scoped>
.promotion-timer {
  min-width: 115px;

  @include flex-container(column, center);
  gap: 16px;
  text-align: center;

  border-bottom-right-radius: 8px;

  padding: 28px 8px;

  &.novelty {
    color: #009b3e;
    background-color: rgba(0, 155, 62, 0.1);
  }
  &.runningOut {
    color: #e05507;
    background: rgba(224, 85, 7, 0.1);
  }
  &.onlyToday {
    color: #eb1717;
    background: rgba(235, 23, 23, 0.1);
  }
  &.finished {
    color: #8a8a8a;
    background: rgba(138, 138, 138, 0.1);
  }

  &__text {
    @include font(16, 16, 400);
  }

  &__number {
    @include font(20, 40, 500);
  }
}
</style>
